import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HelperService, ParameterClass } from '../../helpers/helper.service';
import { filterationParams } from '../../params/params';
import { Complaint } from '../../models/CRM/complaints';

@Injectable({
  providedIn: 'root'
})
export class ComplaintsService {

  constructor(private http: HttpClient, private _helper: HelperService) { }
  
  getComplaints(externalParams?: any) {
    let params = new filterationParams
    return this._helper.CallRequestList(`hr/complaints`, this._helper.CreateRequestParameters(externalParams ? externalParams : params.notPaginationParams))
  }

  getComplaint(id: number) {
    return this._helper.CallRequestList(`hr/complaints/${id}`)
  }

  setupComplaint(model: Complaint) {
    return this._helper.createFormData(`hr/complaints`, model)
  }

  reopenTicket(id: number) {
    return this._helper.CallRequestList(`hr/complaints/reopen-ticket/${id}`)
  }
}
